module.exports = __webpack_public_path__ + "static/media/layer_1.16577771.png";